import { useMemo } from 'react';

import StudentCoursePageNotFound from '../StudentCoursePageNotFound';
import StudentCoursePageStudySession from './StudentCoursePageStudySession';

export default function StudentCoursePageStudySessionCtnr({
  course,
  courseSubscription,
  currentUser,
  fetching,
  pathMatchData,
  studySessions,
  subscription,
  userCourse,
}) {
  const studySessionId = +pathMatchData.params.id;
  const studySession = useMemo(
    () => studySessions.find(ss => ss.id === studySessionId),
    [studySessions, studySessionId],
  );

  if (fetching) return null;
  if (!studySession) return <StudentCoursePageNotFound course={course} />;
  return (
    <StudentCoursePageStudySession
      key={studySession.id}
      course={course}
      courseSubscription={courseSubscription}
      currentUser={currentUser}
      studySession={studySession}
      studySessions={studySessions}
      subscription={subscription}
      userCourse={userCourse}
    />
  );
}
